import axios from "axios";
import type { AxiosResponse } from "axios";
import type { ApiResult } from "@/api";
import { Modal } from "ant-design-vue";

const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
});

instance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (res: AxiosResponse<ApiResult<unknown>>) => {
    if (res.data.code === "101") {
      Modal.destroyAll();
      Modal.info({
        title: "系统提示",
        content: "登录状态已过期，请退出重新登录！",
        okText: "重新登录",
        onOk: () => {
          // logout(currentPath);
        },
      });
      return Promise.reject(new Error(res.data.msg));
    }
    return res;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default function request<T>(url: string, type: string, data?: object) {
  if (type === "GET") {
    return instance.get<ApiResult<T>>(url, {
      params: data,
    });
  } else {
    return instance.post<ApiResult<T>>(url, data);
  }
}
